import React from 'react';
import './EiffelArticleBody.css';

/**
 * Renders the `body` array from an eiffelArticles.js entry. Adding a
 * new block type here (and to the data file's comment block) is all
 * that's needed for future articles to use it -- every article page
 * shares this one renderer.
 */
export default function EiffelArticleBody({ blocks }) {
  return (
    <div className="eiffel-body">
      {blocks.map((block, i) => {
        if (block.type === 'paragraph') {
          return <p key={i}>{block.text}</p>;
        }
        if (block.type === 'image') {
          return (
            <figure key={i} className="eiffel-body__figure">
              <img src={block.src} alt={block.caption || ''} />
              {block.caption && <figcaption>{block.caption}</figcaption>}
            </figure>
          );
        }
        if (block.type === 'stat-list') {
          return (
            <div key={i} className="eiffel-body__stat-list">
              <h4>{block.heading}</h4>
              <ul>
                {block.items.map((item, j) => (
                  <li key={j}>{item}</li>
                ))}
              </ul>
            </div>
          );
        }
        if (block.type === 'clue-columns') {
          return (
            <div key={i} className="eiffel-body__clues">
              <div>
                <h4>Across</h4>
                <ul>
                  {block.across.map((c, j) => <li key={j}>{c}</li>)}
                </ul>
              </div>
              <div>
                <h4>Down</h4>
                <ul>
                  {block.down.map((c, j) => <li key={j}>{c}</li>)}
                </ul>
              </div>
            </div>
          );
        }
        return null;
      })}
    </div>
  );
}
